.wrapper {
  flex-direction: column;
}

:host([isTab='true']) {
  .smartviews-header {
    flex-flow: row;
  }
}

.header {
  width: 100%;
  display: flex;
  align-items: center;
  padding: calc(2 * var(--spacer)) calc(3 * var(--spacer)) var(--spacer) calc(2 * var(--spacer));
  flex-wrap: wrap;

  .smartviews-header {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    margin-bottom: calc(var(--spacer) * 2);

    .title {
      flex: 0.8;
      color: var(--main-titles-inputs-600);
      line-height: calc(var(--spacer) * 3);
    }

    .smartviews-actions {
      display: flex;
      justify-content: flex-end;
    }
  }

  .smartviews-actions {
    gz-button {
      display: inline-flex;
      padding: 0 var(--spacer);
      border-right: 1px solid var(--chart-100-pressed);
    }
  }

  .smartviews-filters {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-top: var(--spacer);
  }
}

.grid-view {
  min-height: 100%;
  align-items: stretch;
}

.company-selector {
  width: auto;
}

gz-search-query {
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-color: var(--chart-101-pressed-dividers);
}
